import { voicePerformance } from '@elena/shared';

let context: AudioContext | null = null;

/** Analyze Elena's actual TTS playback. Unsupported/blocked WebAudio leaves playback untouched. */
export async function trackVoiceAudio(audio: HTMLAudioElement): Promise<() => void> {
  if (typeof AudioContext === 'undefined') return () => undefined;
  try {
    context ??= new AudioContext();
    // Give a user-activated context a brief chance to resume, without blocking autoplay fallback.
    if (context.state !== 'running') {
      let guard: number | undefined;
      await Promise.race([
        context.resume().catch(() => undefined),
        new Promise<void>((resolve) => {
          guard = window.setTimeout(resolve, 120);
        }),
      ]);
      window.clearTimeout(guard);
    }
    if (context.state !== 'running') return () => undefined;
    const source = context.createMediaElementSource(audio);
    const analyser = context.createAnalyser();
    analyser.fftSize = 256;
    const frames = new Float32Array(analyser.fftSize);
    source.connect(analyser);
    analyser.connect(context.destination);
    const timer = window.setInterval(() => {
      if (audio.paused) return;
      analyser.getFloatTimeDomainData(frames);
      voicePerformance.sample(frames);
    }, 50);
    return () => {
      window.clearInterval(timer);
      source.disconnect();
      analyser.disconnect();
    };
  } catch {
    return () => undefined;
  }
}
